import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import Captcha from "demos-react-captcha";
import Select from "react-select";
import InputMask from "react-input-mask";

import API from "../../../../api/baseUrl";
import { serialize, original } from "../../../../functions/helper";
import config from "../../../../config.json";
import { enDate, faDate } from "../../../../functions/date";
import weekApi from "../../../../api/week";
import Loading from "../../../../components/loading";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { paymentService } from "../../../../api/payment";

const dateMask = {
	mask: "9999/99/99",
	maskChar: "_",
	alwaysShowMask: false,
	formatChars: {
		9: "[0-9]",
		a: "[A-Za-z]",
		"*": "[A-Za-z0-9]",
	},
	permanents: [2, 5],
};

export default function PaymentAmountPage() {
	const history = useHistory();
	const [loading, setLoading] = useState(true);

	const Login_User_Token = localStorage.getItem("user_login_token");
	const Login_User_cp = localStorage.getItem("user_login_cp");

	const { state } = useLocation();

	const [detail, setDetail] = useState({});
	const [value, setValue] = useState("");
	const [defaultPay, setDefaultPay] = useState("");

	useEffect(() => {
		if (!state?.nationalCode || !state?.phoneNumber) history.push("/");
		else fetchServiceData();
	}, []);

	const fetchServiceData = async () => {
		try {
			const [resDetail, resDefaultPay] = await Promise.all([
				API.post(
					serialize({
						id: 1710,
						sp_param: `'${Login_User_Token}','${Login_User_cp}','0','0','machine_nm','machine_ip','machine_ip'`,
						Login_User_Token,
						Login_User_cp,
					}),
				),
        API.post(
					serialize({
						id: 1750,
						sp_param: `'${Login_User_Token}','${Login_User_cp}','0','0','machine_nm','machine_ip','machine_ip'`,
						Login_User_Token,
						Login_User_cp,
					}),
				),
			]);
			console.log(original(resDefaultPay.data, false));
      setDefaultPay(original(resDefaultPay.data, false)[0])
			setDetail(original(resDetail.data, false)[0]);
			setValue(original(resDefaultPay.data, false)[0].transact_payment);
			setLoading(false);
		} catch (error) {
			console.log(error);
		}
	};

	const handlePayment = () => {
		paymentService(
			state?.nationalCode,
			state?.phoneNumber,
			value,
			"",
			"",
			"222",
			"",
		);
	};

	const handleRedirect = () => {
		// history.push({
		// 	pathname: "/payment/amount",
		// 	state,
		// });
	};

	return (
		<div
			className="fast-visit-page"
			style={{
				background: `linear-gradient(45deg,${
					config.auth_back_color_1
						? config.auth_back_color_1
						: "rgba(86, 0, 110, 1)"
				} 10%,${
					config.auth_back_color_2
						? config.auth_back_color_2
						: "rgba(33, 150, 243, 1)"
				} 100%)`,
			}}
		>
			<div className="fast-visit-page__box">
				<h2 className="fast-visit-page__title">
					{config.payment_page_amount_header_text
						? config.payment_page_amount_header_text
						: "مبلغ قابل پرداخت"}
				</h2>

				<div className="info">
					<table className="table">
						<tbody>
							{Object.entries(detail).map(([key, value], index) => (
								<tr key={index}>
									<td>{key}</td>
									<td>{value}</td>
								</tr>
							))}
						</tbody>
					</table>

					<div className="text-input">
						<br />
						<input
							type="text"
							id="text"
							className="text-input__input ltr"
							value={value}
							onChange={(e) => setValue(e.target.value)}
							placeholder="مبلغ"
						/>
					</div>

					<button
						type="button"
						className="fast-visit-page__form_btn"
						onClick={handlePayment}
					>
						پرداخت
					</button>
				</div>
				<div className="fast-visit-page__form_links">
					<Link to={{ pathname: "/payment/info", state }}>مرحله قبل</Link>
				</div>

				<div className="fast-visit-page__box_footer">
					<span>{enDate}</span>
				</div>
			</div>

			{loading && <Loading />}
		</div>
	);
}
